import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import type { PlatformType } from '../../types';
import { platformPlaceholder, xboxEditionTypePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function XboxEditionSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  filterOptions,
  lang,
}: PlatformType) {
  const options = useMemo(() => {
    if (!filterOptions) {
      return [];
    }
    return (filterOptions?.list || []).map((item: any) => ({
      text: item.entity_name,
      value: item.package_ids?.join('|'),
    }));

  }, [filterOptions]);

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  const { formatMessage } = useIntl();

  const {
    diffClassName,
    selects: xboxEditionSelects,
    setSelects: setXboxEditionSelects,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'game_package_ids',
    options: options?.map((item: any) => item.value),
  });

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'game_package_ids',
      commonBackInfo(
        { game_package_ids: xboxEditionSelects.map((value) => value.split('|')).flat() },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll },
      ),
    );
  }, [xboxEditionSelects, formatMessage]);

  return (
    <div className={`topic-select-wrapper topic-select-wrapper--topic ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={xboxEditionTypePlaceholder[lang]}
        onClear={() => setXboxEditionSelects([])}
        selectOptionsInfo={[xboxEditionSelects, setXboxEditionSelects]}
        options={options}
        pointKey={FilterButtonPoint.xboxEdition}
      ></CustomSelect>
    </div>
  );
}
